(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global['equal-height'] = factory();
}(typeof self !== 'undefined' ? self : this, function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var ResizeSensor_min = createCommonjsModule(function (module, exports) {
    !function (a, b) {
      module.exports = b();
    }(commonjsGlobal, function () {
      var a = function () {

        function a() {
          this.q = [], this.add = function (a) {
            this.q.push(a);
          };
          var a, b;

          this.call = function () {
            for (a = 0, b = this.q.length; b > a; a++) {
              this.q[a].call();
            }
          };
        }

        function b(a, b) {
          return a.currentStyle ? a.currentStyle[b] : window.getComputedStyle ? window.getComputedStyle(a, null).getPropertyValue(b) : a.style[b];
        }

        function c(c, e) {
          if (c.resizedAttached) {
            if (c.resizedAttached) return void c.resizedAttached.add(e);
          } else c.resizedAttached = new a(), c.resizedAttached.add(e);

          c.resizeSensor = document.createElement("div"), c.resizeSensor.className = "resize-sensor";
          var f = "position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden; opacity: 0;",
              g = "position: absolute; left: 0; top: 0; transition: 0s;";
          c.resizeSensor.style.cssText = f, c.resizeSensor.innerHTML = '<div class="resize-sensor-expand" style="' + f + '"><div style="' + g + '"></div></div><div class="resize-sensor-shrink" style="' + f + '"><div style="' + g + ' width: 200%; height: 200%"></div></div>', c.appendChild(c.resizeSensor), "static" == b(c, "position") && (c.style.position = "relative");

          var h = c.resizeSensor.childNodes[0],
              i = h.childNodes[0],
              j = c.resizeSensor.childNodes[1],
              k = function k() {
            i.style.width = 1e5 + "px", i.style.height = 1e5 + "px", h.scrollLeft = 1e5, h.scrollTop = 1e5, j.scrollLeft = 1e5, j.scrollTop = 1e5;
          };

          k();

          var l = !1,
              m = function m() {
            c.resizedAttached && (l && (c.resizedAttached.call(), l = !1), d(m));
          };

          d(m);

          var n,
              o,
              p,
              q,
              r = function r() {
            ((p = c.offsetWidth) != n || (q = c.offsetHeight) != o) && (l = !0, n = p, o = q), k();
          },
              s = function s(a, b, c) {
            a.attachEvent ? a.attachEvent("on" + b, c) : a.addEventListener(b, c);
          };

          s(h, "scroll", r), s(j, "scroll", r);
        }

        var d = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (a) {
          return window.setTimeout(a, 20);
        },
            e = function e(a, b) {
          var d = this,
              e = Object.prototype.toString.call(a),
              f = d._isCollectionTyped = "[object Array]" === e || "[object NodeList]" === e || "[object HTMLCollection]" === e || "undefined" != typeof jQuery && a instanceof window.jQuery || "undefined" != typeof Elements && a instanceof window.Elements;
          if (d._element = a, f) for (var g = 0, h = a.length; h > g; g++) {
            c(a[g], b);
          } else c(a, b);
        };

        return e.prototype.detach = function () {
          var a = this,
              b = a._isCollectionTyped,
              c = a._element;
          if (b) for (var d = 0, f = c.length; f > d; d++) {
            e.detach(c[d]);
          } else e.detach(c);
        }, e.detach = function (a) {
          a.resizeSensor && (a.removeChild(a.resizeSensor), delete a.resizeSensor, delete a.resizedAttached);
        }, e;
      }();

      return a;
    });
  });

  /**
  * Private Variables
   */

  var ehClass = "js-".concat(vl.ns, "equal-height"),
      ehContainerClass = "js-".concat(vl.ns, "equal-height-container"),
      ehContentAwareAtt = "data-".concat(vl.ns, "equal-height-content-aware"),
      dataPrefix = "data-".concat(vl.ns),
      ehAtt = "".concat(dataPrefix, "equal-height"),
      ehContainerAtt = "".concat(ehAtt, "-container");

  var _syncHeights = function _syncHeights(container) {
    var nodeList = container.querySelectorAll(".".concat(ehClass, ", [").concat(ehAtt, "]")),
        elems = Array.from(nodeList),
        tallest;
    tallest = Math.max.apply(Math, elems.map(function (elem) {
      elem.style.minHeight = ''; // clean first

      elem.style.height = ''; // clean first

      return elem.offsetHeight;
    }));
    tallest++;
    vl.util.each(elems, function (elem) {
      if (elem.hasAttribute(ehAtt) && elem.getAttribute(ehAtt) === 'height') {
        elem.style.height = "".concat(tallest, "px");
      } else {
        elem.style.minHeight = "".concat(tallest, "px");
      }
    });
  };

  var EqualHeight =
  /*#__PURE__*/
  function () {
    function EqualHeight() {
      _classCallCheck(this, EqualHeight);

      this.resized = true;
    }

    _createClass(EqualHeight, [{
      key: "resize",
      value: function resize(containers) {
        var _this = this;

        if (this.resized) {
          window.requestAnimationFrame(function () {
            _this.resized = true; // Apply per container

            vl.util.each(containers, function (container) {
              _this.dress(container);
            });
          });
        }

        this.resized = false;
      }
    }, {
      key: "dress",
      value: function dress(container) {
        _syncHeights(container);
      }
    }, {
      key: "dressAll",
      value: function dressAll() {
        var _this2 = this;

        var containers = document.querySelectorAll(".".concat(ehContainerClass, ":not([data-").concat(vl.ns, "js-dress=\"false\"]),\n      [").concat(ehContainerAtt, "]:not([data-").concat(vl.ns, "js-dress=\"false\"])"));
        this.resize(containers);
        window.addEventListener('resize', vl.util.debounce(function () {
          _this2.resize(containers);
        }, 100), false);
        vl.util.each(containers, function (container) {
          if (container.hasAttribute(ehContentAwareAtt) && container.getAttribute(ehContentAwareAtt) === 'true') {
            if (vl.util.exists(ResizeSensor_min)) {
              new ResizeSensor_min(container, function () {
                _this2.resize(containers);
              });
            }
          }
        });
      }
    }]);

    return EqualHeight;
  }();

  if (!('equalHeight' in vl)) {
    vl.equalHeight = new EqualHeight();
    window.addEventListener('load', function (event) {
      vl.equalHeight.dressAll();
    });
  }

  return EqualHeight;

}));
